export default __webpack_public_path__ + "static/media/ananya.53c64f20.png";